import { DashboardGuard } from './dashboard/dashboard.guard';
import { MyTasksGuard } from './mytasks/mytasks.guard';
import { WorkRequestGuard } from './workRequest/workRequest.guard';
import { AdminGuard } from './admin/admin.guard';


export const guards: any[] = [
  DashboardGuard,
  MyTasksGuard,
  WorkRequestGuard,
  AdminGuard
];


export * from './dashboard/dashboard.guard';
export * from './mytasks/mytasks.guard';
export * from './workRequest/workRequest.guard';
export * from './admin/admin.guard';